/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { arrays_equal, clip, htmlspecialchars } from './util.js';
import { startProgress, stopProgress } from './progress-util.js';
import { closeDialog, scrollElementIntoView } from './dialog-util.js';
import { confirm_box } from './page-modal.js';
import { showInfoToast, showWarningToast } from './snackbar.js';
import { jQuery } from '../other/jquery-hooked.js';
import { postToBackend2 } from './fetch-util.js';
import { mjt } from './i18ntexts.js';
import { MDTimezones } from './timezone.js';

import { MDLocale } from './locale-impl.js';

import { MDMedia } from './media-data.js';
import { MVMediaMetadata } from './media-data-view.js';
import { MDMeta } from './meta-data.js';
import { MTemplates } from './templates.js';
import { MThumbnails } from './thumbnails.js';
import { MetaUtilAutoNumbering } from './util-auto-numbering.js';
import { mjWidgetOverlayEditor } from './widget-overlay-editor.js';


export let MVMediaMetaBatchProcessing = function($) {

	let m_head_html = null;

	let m_dlg_id = 'mmbp-form',
		m_dlg = null,
		m_dlg_w = 554,
		m_dlg_h = 466,

		m_meta_ids = [],
		m_meta_ids_idx = 0,

		m_meta_id = 0,
		m_meta_def = null,

		m_auto_numbering_available = false,
		m_insert_other_available = false,
		m_value = [''],
		m_media_id = 0,
		m_media_ids = [],
		m_select_meta_cb = null,
		m_done_cb = null;

	let m_setupMetadataEditWidget = null;
	let m_getMetadataEditWidgetDataFn = null;

	let m_xMUANC = null;


	function normalize_value( v ) {
		let r=[];
		const l=v.length;
		for( var i=0; i<l; ++i ) r[i] = v[i].normalize('NFC');
		return r;
	}

	function _destroy_dlg() {
		$(document).off('.MVMediaMetaBatchProcessing');
		_destroy_dlg_contents();
		$('#ummbp-head').remove();
		if( m_dlg ) {
			m_dlg.dialog('destroy');
			m_dlg = null;
		}
	}

	function _destroy_dlg_contents() {
		m_xMUANC = null;
		$('#ui-datepicker-div').datepicker('hide').datepicker('destroy');
		$('#mmbp-replace')
			.find('.mmbp-replace-apply-changes')
			.off().prop('disabled',true)
			.end()
			.find('.mmbp-replace-field-config-form')
			.hide();
		$('#mmbp-replace')
			.find('tr.xrow').remove();
	}

	function _prepare_dlg() {
		_destroy_dlg();
		m_dlg = $('#'+m_dlg_id);
	}

	function _compute_dlg_dimensions() {
		const win = $(window);
		const max_w = 1200;
		m_dlg_w = Math.min( Math.max( win.width()-16-40,740), max_w );
		const max_h = 4*1200-40;
		m_dlg_h = Math.min( Math.max(win.height()-20-40,290), max_h );
	}

	function _setup_and_show_dlg() {
		m_dlg_w = 554;
		m_dlg_h = 466;
		m_dlg.dialog( {
			width: m_dlg_w,
			height: m_dlg_h,
			modal: true,
			resizable: false,
			autoOpen: false,
			closeOnEscape: false,
			close: function(ev,ui) {
				_destroy_dlg();
			},
			open: function(ev,ui) {
				_destroy_dlg_contents();
				$('#mmbp-form').closest('.ui-dialog').children('.ui-dialog-titlebar').append(m_head_html);

				const dlg_title = mjt('mmbp-replace-title-detailed','!')
					.replace('%1',m_meta_def.lname)
					.replace('%2',m_meta_id)
					.replace('%3',MDMeta.getTypeName(m_meta_def.type,m_meta_def.list==1));
				$('#ummbp-title').html(dlg_title);

				// <SETUP NAVIGATION>
				$('#ummbp-nav').hide();
				$('#ummbp-title').show();
				if( m_meta_ids.length > 1  ) {
					$('#ummbp-info').text( mjt('mmbp-replace-nav-info','!').replace('%1',m_meta_ids_idx+1).replace('%2',m_meta_ids.length) );
					const next_idx = (m_meta_ids_idx+1) % m_meta_ids.length;
					const prev_idx = (m_meta_ids_idx+m_meta_ids.length-1) % m_meta_ids.length;
					$('#ummbp-prev')
						.show()
						.off()
						.mousedown(function(e) {
							// avoid dialog-dragging on button
							e.stopPropagation();
						})
						.click(function() {
							select_meta_id(prev_idx,false);
						});
					$('#ummbp-next')
						.show()
						.off()
						.mousedown(function(e) {
							// avoid dialog-dragging on button
							e.stopPropagation();
						})
						.click(function() {
							select_meta_id(next_idx,false);
						});
					$('#ummbp-nav').show();
					//$('#ummbp-title').hide();
				} else {
					$('#ummbp-prev,#ummbp-next').hide();
				}
				// </SETUP NAVIGATION>

				openInReplaceMode();
			},
		} );
		_compute_dlg_dimensions();
		m_dlg
			.dialog('option',{'width':m_dlg_w,'height':m_dlg_h})
			.dialog('option','position',{my:'center',at:'center',of:window})
			.dialog('open');
		$(document)
			.off('.MVMediaMetaBatchProcessing')
			.on('mjswinresize.MVMediaMetaBatchProcessing', $.debounce( 250, function(e,w,h) {
				_compute_dlg_dimensions();
				m_dlg.dialog('option',{'width':m_dlg_w,'height':m_dlg_h});
			} )
			)
			.on('keydown.MVMediaMetaBatchProcessing', function(e) {
				if( $('#mj-widget-overlay,#page-blocking-overlay,#progress,#mvl-values').is(':visible') ) return true;
				if( $('.edit-item-form',m_dlg).is(':visible') && $('.edit-item-form :focus',m_dlg).filter(':input').length ) return true;

				let cur_active_row, new_active_row;
				switch( e.which ) {
				case 37: // LEFT
					$('#ummbp-prev').filter(':visible').trigger('click');
					e.preventDefault();
					e.stopPropagation();
					return false;
				case 39: // RIGHT
					$('#ummbp-next').filter(':visible').trigger('click');
					e.preventDefault();
					e.stopPropagation();
					return false;

				case 38: // UP
					cur_active_row = $('#mmbp-replace > div.mmbp-item-list > table tbody > tr.xrow.active');
					if( (new_active_row=cur_active_row.prevAll('tr.xrow:not(.disabled)').first().addClass('active')).length ) cur_active_row.removeClass('active');
					new_active_row.children('.col2').click();
					e.preventDefault();
					e.stopPropagation();
					return false;
				case 40: // DOWN
					cur_active_row = $('#mmbp-replace > div.mmbp-item-list > table tbody > tr.xrow.active');
					if( (new_active_row=cur_active_row.nextAll('tr.xrow:not(.disabled)').first().addClass('active')).length ) cur_active_row.removeClass('active');
					new_active_row.children('.col2').click();
					e.preventDefault();
					e.stopPropagation();
					return false;
				case 27: // ESCAPE
					var edit_forms = $('.edit-item-form',m_dlg);
					if( edit_forms.length ) {
						edit_forms.first().find('.edit-buttons button.cancel').trigger('click');
					} else {
						closeDialog( m_dlg );
					}
					e.preventDefault();
					e.stopPropagation();
					return false;
				}
			} );
	}

	function queryBatchProcessingInfo( media_ids, success_cb, error_cb, silent ) {
		silent = !!silent;
		if( !silent ) startProgress();
		postToBackend2( 'json/media/meta-bpinfo', 'media_ids='+encodeURIComponent(media_ids.join(',')), function(j) {
			if( !silent ) stopProgress();
			if( j && j.hasOwnProperty('meta') ) {
				// success
				success_cb( j.meta, j.r_edit );
			} else if( error_cb ) {
				error_cb(j&&j.error?j.error:'unknown error');
			}
		}, function() {
			// timeout
			if( !silent ) stopProgress();
			if( error_cb ) error_cb('timeout');
		}, function( XMLHttpRequest, textStatus ) {
			// other error
			if( !silent ) stopProgress();
			if( error_cb && (XMLHttpRequest.statusText??null)!=='abort' ) error_cb(XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.error ? XMLHttpRequest.responseJSON.error : XMLHttpRequest.status);
		} );
	}

	function isAutoNumberingAvailableForMetaDef( meta_def ) {
		// possible types: 0=string, 1=text, 7=datetime
		if( meta_def.type!=0 && meta_def.type!=1 && meta_def.type!=7 ) return false;
		// must be user-editable
		if( !meta_def.usre ) return false;
		// must have options.ui_mode=edit
		const ui_mode = meta_def.hasOwnProperty('options') && meta_def.options.hasOwnProperty('ui_mode') ? meta_def.options.ui_mode : 'show';
		if( ui_mode!='edit' ) return false;
		// must NOT have options.vl_mode=fixed
		const vl_mode = meta_def.hasOwnProperty('options') && meta_def.options.hasOwnProperty('vl_mode') ? meta_def.options.vl_mode : 'free';
		if( vl_mode=='fixed' ) return false;
		return true;
	}

	function isInsertOtherAvailableForMetaDef( meta_def ) {
		// possible types: 0=string, 1=text
		if( meta_def.type!=0 && meta_def.type!=1 ) return false;
		// must be user-editable
		if( !meta_def.usre ) return false;
		// must have options.ui_mode=edit
		const ui_mode = meta_def.hasOwnProperty('options') && meta_def.options.hasOwnProperty('ui_mode') ? meta_def.options.ui_mode : 'show';
		if( ui_mode!='edit' ) return false;
		// must NOT have options.vl_mode=fixed
		const vl_mode = meta_def.hasOwnProperty('options') && meta_def.options.hasOwnProperty('vl_mode') ? meta_def.options.vl_mode : 'free';
		if( vl_mode=='fixed' ) return false;
		return true;
	}



	function openAutoNumberingConfig( node, part_indices, changed_cb ) {
		const anc_part = m_xMUANC.getPartAt(part_indices[0],part_indices[1]);
		// if( anc_part===null ) {
		// }
		const anc_options = m_xMUANC.getOptionsForPart(anc_part,true,m_media_id,m_media_ids);
		function setup_cb( elem, val, ovl ) {
			$('#mmbp-replace-field-config-form-auto-num-tmpl')
				.clone(true)
				.attr('id','mmbp-replace-field-config-form-auto-num')
				.appendTo(ovl)
				.show();
			const an_config_form = ovl.find('.mmbp-replace-field-config-form');
			$('.mmbp-replace-offset-1',an_config_form)
				.mjWidget({type:'int',id:'mmbp-replace-offset',name:'offset','default':anc_options.offset});
			$('.mmbp-replace-incr-1',an_config_form)
				.mjWidget({type:'int',id:'mmbp-replace-incr',name:'incr','default':anc_options.incr});
			$('.mmbp-replace-lpad-1',an_config_form)
				.mjWidget({type:'int',id:'mmbp-replace-lpad',name:'lpad','default':anc_options.lpad});

			$('.mmbp-deactivate-part',an_config_form)
				.prop('disabled',!anc_part.isEnabled())
				.click( function() {
					mjWidgetOverlayEditor.close();
					m_xMUANC.enablePart(part_indices[0],part_indices[1],false,null);
					if( changed_cb ) changed_cb(false,null);
					return false;
				} );
		}
		function extract_cb( ovl ) {
			const opts = {
				offset:	clip( $('.mmbp-replace-offset-1',ovl).mjWidget('get'), -2147483640, 2147483647 ),
				incr:	clip( $('.mmbp-replace-incr-1',ovl).mjWidget('get'), -2000000000, 2000000000 ),
				lpad:	clip( $('.mmbp-replace-lpad-1',ovl).mjWidget('get'), 0, 32 ),
			};
			if( opts.incr==0 ) opts.incr = 1;
			return opts;
		}
		function accept_cb( opts ) {
			m_xMUANC.enablePart(part_indices[0],part_indices[1],true,opts);
			if( changed_cb ) changed_cb(true,opts);
		}
		const ovl_options = {
			'OverlayCssWidth': 'auto',
			'OkButtonText': anc_part.isEnabled() ? mjt('mmbp-apply-options','!') : mjt('mmbp-activate-part-and-apply-options','!'),
		};
		mjWidgetOverlayEditor.open(node,part_indices,setup_cb,extract_cb,accept_cb,null,ovl_options);
	}


	function openInsertOtherConfig( node, part_indices, changed_cb ) {
		const anc_part = m_xMUANC.getPartAt(part_indices[0],part_indices[1]);
		const anc_options = m_xMUANC.getOptionsForPart(anc_part,true,m_media_id,m_media_ids);
		function setup_cb( elem, val, ovl ) {
			$('#mmbp-replace-field-config-form-insert-other-tmpl')
				.clone(true)
				.attr('id','mmbp-replace-field-config-form-insert-other')
				.appendTo(ovl)
				.show();
			const an_config_form = ovl.find('.mmbp-replace-field-config-form');
			$('.mmbp-replace-insert-from-meta-id-1',an_config_form)
				.mjWidget({type:'meta-field',id:'mmbp-replace-insert-from-meta-id',name:'insert-from-meta-id','default':anc_options.source_meta_id,flt_cb:function(meta_id,md) {
					// remove fields "internal" flag, binary fields
					if( md.intr || md.type==4 ) return false;
					return true;
				} } );
			$('.mmbp-replace-combine-string-1',an_config_form)
				.mjWidget({type:'string',id:'mmbp-replace-combine-string',name:'text-combine-string','default':anc_options.text_combine_string});
			$('.mmbp-replace-whole-empty-when-empty-1',an_config_form)
				.mjWidget({type:'bool2',id:'mmbp-replace-whole-empty-when-empty',name:'whole-empty-when-empty','default':anc_options.whole_empty_when_empty});
			$('.mmbp-deactivate-part',an_config_form)
				.prop('disabled',!anc_part.isEnabled())
				.click( function() {
					mjWidgetOverlayEditor.close();
					m_xMUANC.enablePart(part_indices[0],part_indices[1],false,null);
					if( changed_cb ) changed_cb(false,null);
					return false;
				} );
		}
		function extract_cb( ovl ) {
			const opts = {
				source_meta_id:			$('.mmbp-replace-insert-from-meta-id-1',ovl).mjWidget('get'),
				text_combine_string:	$('.mmbp-replace-combine-string-1',ovl).mjWidget('get'),
				whole_empty_when_empty:	$('.mmbp-replace-whole-empty-when-empty-1',ovl).mjWidget('get'),
			};
			return opts;
		}
		function accept_cb( opts ) {
			m_xMUANC.enablePart(part_indices[0],part_indices[1],true,opts);
			if( changed_cb ) changed_cb(true,opts);
		}
		const ovl_options = {
			'OverlayCssWidth': 'auto',
			'OkButtonText': anc_part.isEnabled() ? mjt('mmbp-apply-options','!') : mjt('mmbp-activate-part-and-apply-options','!'),
		};
		mjWidgetOverlayEditor.open(node,part_indices,setup_cb,extract_cb,accept_cb,null,ovl_options);
	}



	function getProcessedValue( idx, media_id, media_meta ) {
		const new_val_arr = m_xMUANC.getProcessedValue(idx,media_meta);

		if( m_meta_def.type==7 ) {
			// normalize processed datetimes...
			for( var i=0; i<new_val_arr.length; ++i ) {
				const dt = new_val_arr[i];
				if( dt==='' ) continue; // keep empty string as-is
				const dpt = dt.split(' '); // date, time
				const dt0 = dpt[0].split('-'); // year, month, day
				let dt_arr = [ dt0[0]||1900, dt0[1]||1, dt0[2]||1 ];
				let has_time = false;
				if( dpt.length>1 ) {
					const tt0 = dpt[1].split(':');
					dt_arr.push(tt0[0]||0,tt0[1]||0,tt0[2]||0);
					has_time = true;
				} else {
					dt_arr.push(0,0,0);
				}
				// convert to date object (to normalize invalid months, days, etc)
				const dt_obj = MDTimezones.mj_datetime_to_date_object(dt_arr);
				// convert back to string
				let dt_str = MDTimezones.mj_date_object_to_datetime_string(dt_obj);
				if( !has_time ) dt_str = dt_str.substr(0,10); // remove time, keep date part only
				new_val_arr[i] = dt_str;
			}
		}

		let media_meta_update_list = [];
		media_meta_update_list.push( [media_id,new_val_arr] );
		let cur_dtinfos = {};
		cur_dtinfos[media_id] = { meta:media_meta };
		const r = MDMedia.triggerMetaValueListPlugins( m_meta_id, media_meta_update_list, cur_dtinfos );
		const changes = r[0][media_id] || {};
		return changes[m_meta_id] || new_val_arr;
	}


	function _updateDisplayList( apply_cb ) {
		const mmbp_replace_div = $('#mmbp-replace');
		const info_div = mmbp_replace_div.find('div.mmbp-field-info');
		const table = mmbp_replace_div.children('div.mmbp-item-list').children('table');
		const tbody = table.find('tbody');
		let media_meta_update_list = [];
		let editable_count = 0;
		tbody.children('tr.xrow')
			.filter('.active').removeClass('active').end()
			.each( function(idx,row) {
				const edat = $.data(this);
				if( edat.media_id == m_media_id ) {
					if( arrays_equal(m_value,edat.cur_val_arr) ) {
						// mark row active only if it is current m_media_id AND
						// its original cur_val_arr matches m_value exactly (if not, then the user has entered another value ...)
						info_div.removeClass('active');
						$(this).addClass('active');
					} else {
						// mark the info_div as active instead
						info_div.addClass('active');
					}
				}
				if( edat.can_edit ) {
					editable_count ++;
					const new_val_arr2 = getProcessedValue(idx,edat.media_id,edat.media_meta);
					const val_eq_db = arrays_equal(edat.cur_val_arr,new_val_arr2);
					const val_eq_last = arrays_equal(edat.new_val_arr,new_val_arr2);
					if( !val_eq_last ) {
						$.data(this,'new_val_arr',new_val_arr2);
						let new_val_html;
						if( m_meta_def.type==7 ) {
							new_val_html = MVMediaMetadata.getInteractiveDisplayData(new_val_arr2,m_meta_def||m_meta_id,{linkToSearch:false});
						} else {
							new_val_html = MVMediaMetadata.getNonInteractiveDisplayData(new_val_arr2,m_meta_def||m_meta_id);
						}
						$('> td.col3',this)
							.html( new_val_html )
							.stop().fadeTo( 50, 0.3, function() {
								$(this).fadeTo(500,1.0);
							} );
					}
					$(this).toggleClass('changed',!val_eq_db);
					if( !val_eq_db ) media_meta_update_list.push( [edat.media_id,new_val_arr2] );
				}
			} );
		if( apply_cb ) {
			media_meta_update_list.reverse();
			apply_cb(media_meta_update_list,editable_count);
		}
	}

	function updateDisplayList() {
		_updateDisplayList( function( media_meta_update_list, editable_count ) {
			const mmbp_replace_div = $('#mmbp-replace');
			const actual_update_count = media_meta_update_list.length;
			if( editable_count==0 ) {
				$('.mmbp-replace-apply-changes',mmbp_replace_div).prop('disabled',true);
				$('.mmbp-menu .hint',mmbp_replace_div).text(mjt('mmbp-replace-not-available-insufficient-permissions','!'));
			} else if( actual_update_count==0 ) {
				$('.mmbp-replace-apply-changes',mmbp_replace_div).prop('disabled',true);
				$('.mmbp-menu .hint',mmbp_replace_div).text(mjt('mmbp-replace-nothing-to-update','!'));
			} else {
				$('.mmbp-replace-apply-changes',mmbp_replace_div).prop('disabled',false);
				$('.mmbp-menu .hint',mmbp_replace_div).text(mjt('mmbp-replace-save-hint','!'));
			}
		} );
	}

	function createItemRow( media_id, title, cur_val_arr, new_val_arr, can_edit, media_meta, draggable ) {
		let cur_val_display_html;
		let new_value_display_html;
		if( m_meta_def.type==7 ) {
			// for datetime differences between edit and data -> use interactive display
			cur_val_display_html = MVMediaMetadata.getInteractiveDisplayData(cur_val_arr,m_meta_def||m_meta_id,{linkToSearch:false});
			new_value_display_html = can_edit ? MVMediaMetadata.getInteractiveDisplayData(new_val_arr,m_meta_def||m_meta_id,{linkToSearch:false}) : cur_val_display_html;
		} else {
			cur_val_display_html = MVMediaMetadata.getNonInteractiveDisplayData(cur_val_arr,m_meta_def||m_meta_id);
			new_value_display_html = can_edit ? MVMediaMetadata.getNonInteractiveDisplayData(new_val_arr,m_meta_def||m_meta_id) : cur_val_display_html;
		}
		let row_html = '<tr class="xrow">';
		row_html+= '<td class="dcompact3 col1">';
		row_html+= '<div class="mmbp-item">';
		row_html+= '<div class="mmbp-item-thumb">'+media_id+'</div>';
		row_html+= '<div class="mmbp-item-media-id">ID: '+media_id+'</div>';
		row_html+= '<div class="mmbp-item-title" title="'+htmlspecialchars(title,true,true)+'">'+htmlspecialchars(title)+'</div>';
		row_html+= '</div>';
		row_html+= '</td>';
		row_html+= '<td class="dcompact3 col2">'+cur_val_display_html+'</td>';
		row_html+= '<td class="dcompact3 col3">'+new_value_display_html+'</td>';
		row_html+= '<td class="dcompact3 col4"><span class="delete-link">'+mjt('mmbp-item-remove')+'</span></td>';
		row_html+= (draggable?'<td class="dcompact3 col5 draghandle" title="'+mjt('mmbp-item-drag')+'"></td>':'');
		row_html+= '</tr>';
		const row = $(row_html);
		const row0 = row[0];
		$.data(row0,'cur_val_arr',cur_val_arr);
		$.data(row0,'new_val_arr',new_val_arr);
		$.data(row0,'media_id',media_id);
		$.data(row0,'can_edit',can_edit);
		$.data(row0,'media_meta',media_meta);
		MThumbnails.createOnTarget(
			row.find('.mmbp-item-thumb')[0],
			{
				media_id: media_id,
				width: 55,
				height: 45,
				meta: media_meta,
				thumb_loader_anim: true,
			}
		);
		return row;
	}

	function renderDisplayList() {
		queryBatchProcessingInfo( m_media_ids, function( meta, r_edit ) {
			const mmbp_replace_div = $('#mmbp-replace');
			const table = mmbp_replace_div.children('div.mmbp-item-list').children('table');
			const tbody = table.find('tbody').empty();
			const ml = m_media_ids.length;
			for( var i=0; i<ml; ++i ) {
				const media_id = m_media_ids[i];
				const mm = meta[media_id] || {};
				const title = mm[101] ? mm[101][0] : '';
				const cur_val_arr = mm[m_meta_id] ? normalize_value(mm[m_meta_id]) : [''];
				const new_val_arr = getProcessedValue(i,media_id,mm);
				const can_edit = !!r_edit[media_id];
				const row = createItemRow(media_id,title,cur_val_arr,new_val_arr,can_edit,mm,true);
				if( media_id==m_media_id ) row.addClass('active');
				if( !can_edit ) row.addClass('disabled').children('.col3').html('<i>'+mjt('mmbp-no-write-permission')+'</i>');
				row.children('.col2')
					.addClass('linked')
					.click( function() {
						const row = $(this).closest('tr');
						const row0 = row[0];
						// select this entry and use its value for further processing
						selectMediaAndSetValue( $.data(row0,'media_id'), $.data(row0,'cur_val_arr'), false );
						// then scroll to a position where the row is actually visible"!
						requestAnimationFrame( function() {
							// the offset parent is #mmbp-form, but somehow the offset of the table itself got lost,
							// so, add that back again (as missing_offset)
							const missing_offset = $('.mmbp-item-list')[0].offsetTop;
							scrollElementIntoView( row, $('#mmbp-form'), missing_offset );
						} );
					} )
					.end()
					.find('> .col4 > .delete-link')
					.click( function() {
						const row = $(this).closest('tr');
						const media_id = $.data(row[0],'media_id');
						for( var midx=0; midx<m_media_ids.length; ++midx ) {
							if( m_media_ids[midx]==media_id ) {
								// remove table row & remove from m_media_ids
								row.remove();
								m_media_ids.splice(midx,1);
								if( m_media_id==media_id ) m_media_id = 0;
								break;
							}
						}
						if( m_media_ids.length==0 ) hide(false);
						else _updateDisplayList();
					})
					.end()
					.appendTo(tbody);
			}
			table.tableDnD( {
				onDragClass:'dragging',
				dragHandle:'draghandle',
				onDrop:function( table, row ) {
					// use list of media_ids in new order:...
					let media_ids_ordered = [];
					for( var i=1; i<table.rows.length; ++i ) media_ids_ordered.push( $.data(table.rows[i],'media_id') );
					m_media_ids = media_ids_ordered;
					_updateDisplayList();
				},
			} );
			$('.mmbp-replace-apply-changes',mmbp_replace_div)
				.prop('disabled',true)
				.click( function() {
					// update states once again -
					_updateDisplayList( function( media_meta_update_list ) {
						const sending_update_count = media_meta_update_list.length;
						if( sending_update_count > 0 ) {
							let txt = mjt('md-confirm-save-auto-num-1');
							if( sending_update_count!=1 ) txt = mjt('md-confirm-save-auto-num').replace('%1','<span class="big">'+MDLocale.fmt_number(sending_update_count)+'</span>').replace('%2','<span class="big">'+MDLocale.fmt_number(m_media_ids.length)+'</span>');
							confirm_box(mjt('md-confirm-save-auto-num-title'),txt,function() {
								MDMedia.saveMetaValueList( m_meta_id, media_meta_update_list, function( updated_data ) {
									// success
									const actually_updated_count = updated_data.hasOwnProperty('actually_changed_ids') ? updated_data.actually_changed_ids.length : sending_update_count;
									let info_text = actually_updated_count==1 ? mjt('md-info-saved-auto-num-1') : mjt('md-info-saved-auto-num').replace('%1',actually_updated_count);
									if( actually_updated_count!==sending_update_count ) {
										const diff_count = sending_update_count - actually_updated_count;
										const diff_text = diff_count==1 ? mjt('md-info-saved-auto-num-partial-note-1') : mjt('md-info-saved-auto-num-partial-note').replace('%1',diff_count);
										info_text += '\n' + diff_text;
									}
									showInfoToast(info_text);
									hide(false);
								}, function( error ) {
									// TODO: localize error message:
									showWarningToast( 'Fehler, Daten konnten nicht gespeichert werden. ' + error );
								} );
							});
						} else {
							// no change
							showInfoToast( mjt('md-info-saved-auto-num-0') );
							hide(false);
						}
					});
				} );
			updateDisplayList();
		} );
	}

	function renderFieldInfoDiv() {
		const mmbp_replace_div = $('#mmbp-replace');
		const info_div = mmbp_replace_div.find('div.mmbp-field-info');

		info_div
			.empty()
			.attr('mj_meta_type',m_meta_def.type)
			.show();

		const list_mode_is_sep = !!( m_meta_def.options.list_mode && m_meta_def.options.list_mode=='separator' );
		let list_sep, list_sep1;
		if( list_mode_is_sep ) {
			list_sep =	m_meta_def.options.hasOwnProperty('list_sep') && m_meta_def.options.list_sep.length ? m_meta_def.options.list_sep.replace(/N/g,'\n') : ',;\n',
			list_sep1 = list_sep.charAt(0)+' ';
		} else {
			list_sep1 = '<hr noshade="noshade" />';
		}
		const pl_arr = m_xMUANC.getPartLists();

		for( var pl_idx=0; pl_idx<pl_arr.length; ++pl_idx ) {
			if( pl_idx>0 ) info_div.append(list_sep1);
			const p_arr = pl_arr[pl_idx].getParts();

			for( var p_idx=0; p_idx<p_arr.length; ++p_idx ) {
				const part = p_arr[p_idx];

				const partEnabled = !!m_xMUANC.isPartEnabled(pl_idx,p_idx);

				if( m_auto_numbering_available && part.isNumber() ) {
					$('<span class="part number" tabindex="0" />')
						.text( part.getValue() )
						.data( 'pidx', [pl_idx,p_idx] )
						.attr( 'title', mjt('mmbp-field-edit-candidate-hint-auto-num','!') )
						.toggleClass('enabled',partEnabled)
						.appendTo( info_div )
						.on('click', function() {
							const p_elem = $(this);
							const p_iii = p_elem.data('pidx');
							openAutoNumberingConfig( p_elem, p_iii, function( enabled, options ) {
								p_elem.toggleClass('enabled',enabled);
								// simple update -> use fast updateDisplayList()
								updateDisplayList();
							} );
						} );
				} else if( m_insert_other_available && part.isToken() ) {
					$('<span class="part token" tabindex="0" />')
						.text( part.getValue() )
						.data( 'pidx', [pl_idx,p_idx] )
						.attr( 'title', mjt('mmbp-field-edit-candidate-hint-insert-other','!') )
						.toggleClass('enabled',partEnabled)
						.appendTo( info_div )
						.on('click', function() {
							const p_elem = $(this);
							const p_iii = p_elem.data('pidx');
							openInsertOtherConfig( p_elem, p_iii, function( enabled, options ) {
								p_elem.toggleClass('enabled',enabled);
								// simple update -> use fast updateDisplayList()
								updateDisplayList();
							} );
						} );
				} else {
					$('<span class="part '+(part.isWhitespace()?'whitespace':'text')+'" />')
						.html( htmlspecialchars(part.getValue()) )
						.appendTo(info_div);
				}
			}
		}

		$('<button type="button" class="iconic edit-item" title="'+mjt('mmbp-replace-field-edit')+'"></button>')
			.prependTo(info_div)
			.click( function() {
				$('.mmbp-replace-apply-changes',mmbp_replace_div).prop('disabled',true);
				let html = '<form class="edit-item-form" method="post" accept-charset="UTF-8">';
				html += '<div class="edit-widgets"></div>';
				html += '<div class="edit-buttons">';
				html += '<button type="submit" class="iconic submit" title="'+mjt('mmbp-apply-pattern')+'"></button>';
				html += '<button type="button" class="iconic cancel" title="'+mjt('cancel')+'"></button>';
				html += '</div>';
				html += '</form>';
				info_div.html(html);
				const form = info_div.find('.edit-item-form');
				const btns_div = form.find('.edit-buttons');
				const wdgs_div = form.find('.edit-widgets');
				let focus_node = null;
				function on_cancel() {
					info_div.empty();
					renderFieldInfoDiv();
					renderDisplayList();
					return false;
				}
				btns_div.children('.cancel').click( on_cancel );
				form.submit( function() {
					const value = m_getMetadataEditWidgetDataFn(m_meta_def,wdgs_div);
					selectMediaAndSetValue(m_media_id,value,false);
					return false;
				} );

				focus_node = m_setupMetadataEditWidget(m_meta_def,btns_div,wdgs_div,focus_node,m_value);

				// keyhandler for ESC (will close edit mode and avoid closing the dialog)
				wdgs_div.on('keydown','input[type=text],textarea,select,button', function(e) {
					if( !e.isDefaultPrevented() ) {
						if( e.which && e.which===27 ) {
							if( $(this).areacomplete('isListVisible') ) {
								// ignore -> let "areacomplete" code handle ESC keydown
							} else {
								if( $('#mvl-values').is(':visible') ) return true;
								on_cancel();
							}
							e.preventDefault();
							e.stopPropagation();
						} else if( e.which && e.which===13 && (e.ctrlKey || e.metaKey || e.shiftKey) ) {
							// ENTER
							e.preventDefault();
							e.stopPropagation();
							form.submit();
						}
					}
				} );

				if( focus_node ) {
					if( focus_node.is('input[type=text]') ) focus_node.select();
					else focus_node.focus();
				}
			} )
			.focus();
	}

	function selectMediaAndSetValue( media_id, value, initial ) {
		m_media_id = media_id;
		m_value = value;

		let parseOpts = {
			negative_numbers: true,
		};
		if( m_meta_def.type==7 ) {
			// datetimes: dont try to parse negative numbers (as in "2020-09-04 12:34:56")
			parseOpts.negative_numbers = false;
		}

		m_xMUANC.parseFromValue(m_value,parseOpts,!initial);
		renderFieldInfoDiv();
		if( initial ) renderDisplayList();
		else updateDisplayList();
	}

	function openInReplaceMode() {
		const mmbp_replace_div = $('#mmbp-replace');
		const hints_div = mmbp_replace_div.find('div.mmbp-field-info-hints');

		hints_div.children('.hint').hide()
			.filter('.field-info-hints-intro').toggle(m_auto_numbering_available||m_insert_other_available).end()
			.filter('.field-info-hints-auto-num').toggle(m_auto_numbering_available).end()
			.filter('.field-info-hints-insert-other').toggle(m_insert_other_available).end();

		mmbp_replace_div
			.find('.mmbp-field-name').text( m_meta_def.lname ).end()
			.find('.mmbp-field-meta-id').text( m_meta_id ).end()
			.find('.mmbp-field-type').html( MDMeta.getTypeName(m_meta_def.type,m_meta_def.list==1) ).end()
			.find('.mmbp-menu .hint').text('');

		m_xMUANC = MetaUtilAutoNumbering.createCounter(m_meta_id);
		selectMediaAndSetValue(m_media_id,m_value,true);
	}


	function select_meta_id( meta_ids_idx, is_initial_call, initial_meta ) {
		_prepare_dlg();

		m_meta_ids_idx = meta_ids_idx;
		m_meta_id = m_meta_ids[m_meta_ids_idx];
		m_meta_def = null;
		m_select_meta_cb(m_meta_id);

		MDMeta.queryDefinition( m_meta_id, function( md ) {
			m_meta_def = md;
			m_auto_numbering_available = isAutoNumberingAvailableForMetaDef(m_meta_def);
			m_insert_other_available = isInsertOtherAvailableForMetaDef(m_meta_def);

			const _continue_with_m_value = function( value ) {
				m_value = normalize_value(value);
				_setup_and_show_dlg();
			};

			if( is_initial_call ) {
				_continue_with_m_value( initial_meta[m_meta_id] || [''] );
			} else {
				queryBatchProcessingInfo( [m_media_id], function( meta, r_edit ) {
					const mm = meta[m_media_id] || {};
					_continue_with_m_value( mm[m_meta_id] || [''] );
				} );
			}
		} );
	}

	function open( meta_ids, meta_ids_idx, media_id, media_ids, select_meta_cb, done_cb, initial_meta, setupMetadataEditWidgetFn, getMetadataEditWidgetDataFn ) {
		if( m_head_html===null ) {
			m_head_html = $('#ummbp-head').html();
			$('#ummbp-head').remove();
		}
		m_meta_ids = meta_ids;
		m_media_id = media_id;
		m_media_ids = media_ids.slice();
		m_select_meta_cb = select_meta_cb;
		m_done_cb = done_cb;

		m_setupMetadataEditWidget = setupMetadataEditWidgetFn;
		m_getMetadataEditWidgetDataFn = getMetadataEditWidgetDataFn;

		return select_meta_id(meta_ids_idx,true,initial_meta);
	}

	function hide( force ) {
		_destroy_dlg();
		if( !force ) {
			if( m_done_cb ) {
				m_done_cb();
				m_done_cb = null;
			}
		}
	}

	return {
		open: MTemplates.queryDialogHTMLWrappedFn('form_media_batch_processing',open),
		hide: hide,
	};

}(jQuery); // namespace MVMediaMetaBatchProcessing
